"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNoBus = function SvgNoBus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m21.326 8.06-.985-.174a1 1 0 0 0-1.158.811l-.348 1.97a1 1 0 0 0 .811 1.158l2.463.434",
    stroke: "#D0021B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.441,
    cy: 15.998,
    r: 2.25,
    transform: "rotate(10 4.44 15.998)",
    stroke: "#D0021B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.674 15.94-.985-.173a1 1 0 0 1-.81-1.16L2.664 4.475m5.22-.815L20.03 5.8a2 2 0 0 1 1.653 1.959l.02 3.599a.644.644 0 0 0 .26.514c.391.29.585.777.5 1.258l-.903 5.125a1 1 0 0 1-.91.824c-.137.01-.229-.123-.205-.26a2.25 2.25 0 0 0-2.556-2.615M13.5 18c-1.196-.211-5.393-1.102-6.887-1.365M4.18 2.498 17.82 19.9",
    stroke: "#D0021B"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNoBus);
var _default = exports["default"] = Memo;